import type { LocationProjectsListProps } from "./location-projects-list.type";

import WidgetsGrid from "@/components/Elements/WidgetsGrid";
import { PROJECTS_STATISTICS_WIDGETS } from "@/components/ListStatistics/Projects";
import ProjectsTable from "@/components/ListTable/ProjectsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { TAB_KEYS } from "@/constants/TabKeys";
import { PROJECTS_FILTERS } from "@/entities/projects";
import { ListProvider } from "@/modules/list";

const LocationProjectsList = ({
  location,
  loading,
}: LocationProjectsListProps) => {
  return (
    <ListProvider
      endpoint="projects"
      loading={loading}
      storageKey={STORAGE_KEYS.LOCATIONS_PROJECTS}
      contextTabValue={TAB_KEYS.LOCATION_PROJECTS}
      withMetadata={["statistics"]}
      hiddenFilters={{ [PROJECTS_FILTERS.LOCATION_ID]: location?.id ?? "" }}
    >
      <WidgetsGrid widgets={PROJECTS_STATISTICS_WIDGETS}>
        <ProjectsTable />
      </WidgetsGrid>
    </ListProvider>
  );
};

export default LocationProjectsList;
